





















import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {IOrder} from '@/models/IOrder';
import {getOrdersOfSheetOrder} from '@/services/SheetOrderService';
import {DataTableHeader} from 'vuetify';
import LineItemView from '@/components/LineItemView.vue';
import {ModuleShop} from '@/store/modules/ShopModule';
import {ModuleOrganization} from '@/store/modules/OrganizationModule';

@Component({
  components: {
    LineItemView
  }
})
export default class FulfillmentOrderTable extends Vue {
  @Prop({required: true, type: Number}) sheetOrderId!: number;
  loading: boolean = true;
  orders: IOrder[] = [];
  headers: DataTableHeader[] = [
    {text: 'Order ID', sortable: true, value: 'orderName'},
    {text: 'Line Items', sortable: false, value: ''},
  ];

  created() {
    this.loadData();
  }

  get shopId() {
    return ModuleShop.shopId;
  }

  get organizationId() {
    return ModuleOrganization.organizationId;
  }

  async loadData() {
    this.loading = true;
    try {
      this.orders = [];
      this.orders = await getOrdersOfSheetOrder(this.organizationId, this.shopId, this.sheetOrderId);
    } finally {
      this.loading = false;
    }
  }
}
